import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

export const stepStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.space.md}px;
  padding: ${theme.space.xs}px 0;
`;

/* 상태점 10px 고정. */
export const dotStyle = (done: boolean) => css`
  width: 10px;
  height: 10px;
  border-radius: ${theme.radius.pill}px;
  background: ${done ? theme.color.success : theme.color.border};
`;

export const labelStyle = css`
  flex: 0 0 7em;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

/* 날짜 + 시각을 한 줄로. 숫자는 tabular-nums로 자릿수 정렬. */
export const timeStyle = css`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: ${theme.fontSize.sm}px;
  font-variant-numeric: tabular-nums;
`;

/* 날짜 파트 — 살짝 muted. */
export const timeDateStyle = css`
  color: ${theme.color.textMuted};
`;

/* 시각 파트 — 강조(색만, 볼드 없이). */
export const timeClockStyle = css`
  color: ${theme.color.text};
`;

/* 미기록(시작 전/미종료) 단계. */
export const timeEmptyStyle = css`
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

/* 헤더 우측 타임존 배지. */
export const tzBadgeStyle = css`
  padding: 2px 8px;
  border-radius: ${theme.radius.pill}px;
  background: ${theme.color.bg};
  color: ${theme.color.textMuted};
  font-size: ${theme.fontSize.sm}px;
  font-weight: 500;
  letter-spacing: 0.02em;
  white-space: nowrap;
`;

export const footnoteStyle = css`
  margin: ${theme.space.sm}px 0 0;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;
